<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserBan } from '/app/composables/moderation';
import { usePlatform } from '/app/composables/platform';
import { date as formatDate } from '@bignerve/ui-utils';
import NIcon from '/app/components/NIcon.vue';

const props = defineProps({
	placement: {
		type: String,
		default: 'top',
	},
});

const { t } = useI18n();
const userBan = useUserBan();
const { isViewingSelf } = usePlatform();

const dismissed = ref(false);

const shouldShow = computed(() => {
	return (
		userBan.isBanned &&
		!dismissed.value &&
		!isViewingSelf.value
	);
});

const formattedDate = computed(() => {
	if (!userBan.untilDate) return 'YYYY-MM-DD';
	return formatDate(userBan.untilDate, 'YYYY-MM-DD');
});

const handleClose = () => {
	dismissed.value = true;
};
</script>

<template>
	<VTooltip v-if="userBan.isBanned && !isViewingSelf" :shown="shouldShow" :triggers="[]" theme="danger"
		:placement="placement" :auto-hide="false" container="body" :arrow-padding="20" class="inline">
		<slot>
			<span class="inline" aria-hidden="true"></span>
		</slot>
		<template #popper>
			<div class="grid gap-3 text-white max-w-[20rem] p-4">
				<div class="flex items-start justify-between gap-2">
					<RouterLink :to="{ name: 'faqs' }" class="text-white underline hover:text-white/90">
						{{ t('component.user-ban.viewFaqs') }}
					</RouterLink>
					<button type="button" aria-label="Close" class="p-1 rounded hover:bg-white/20 transition-colors"
						@click="handleClose">
						<NIcon as="times-circle-regular" class="text-lg" />
					</button>
				</div>
				<div class="flex flex-col items-center gap-2 text-center">
					<NIcon as="cancel" class="text-4xl text-white/90" />
					<h3 class="font-bold text-lg m-0">
						{{ t('component.user-ban.title') }}
					</h3>
					<p class="text-sm m-0">
						{{ t('component.user-ban.description') }}
						<span class="block font-bold mt-1">{{ formattedDate }}</span>
					</p>
				</div>
			</div>
		</template>
	</VTooltip>
</template>
